import styled from 'styled-components';

export const StyledContainer = styled.div`
  width: 50%;
  margin: 30vh auto;
  text-align: center;
  font-family: bold;
  font-size: 3rem;
`;
